import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { ClubDetails } from 'app/shared/models/class/club/club';
import { ClubService } from 'app/shared/services/club/club.service';
import { DataService } from 'app/shared/services/data/data.service';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { SubscriptionBaseComponent } from 'app/shared/subscriptionBase/subscription-base';

@Component({
  selector: 'app-admin-offer-priority-by-club',
  templateUrl: './admin-offer-priority-by-club.component.html',
  styleUrls: ['./admin-offer-priority-by-club.component.scss']
})
export class AdminOfferPriorityByClubComponent extends SubscriptionBaseComponent implements OnInit {


  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

  displayedColumns: string[] = ['clubCode', 'clubName', 'offerPrioritized', 'edit'];
  dataSource: MatTableDataSource<ClubDetails>;

  length: number;
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 25, 50];
  pageEvent: PageEvent;

  color: ThemePalette = 'primary';

  clubs: ClubDetails[] = [];
  showDetailsClubPriority = false;
  clubCode: string;
  valueInput: string;

  constructor(
    private clubService: ClubService,
    private dataService: DataService,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private route: ActivatedRoute,
    private faIconService: FaiconService,

  ) {
    super();
  }

  ngOnInit() {
    this.initComponent();
    this.initSub();
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  goDetailsClub(club: ClubDetails): void {
    this.clubCode = club.clubCode;
    this.dataService.showDetailsClubPriority$.next(!this.showDetailsClubPriority);
    this.dataService.clubPriorityOffer$.next(club);
    this.dataService.titleOfferPriority$.next(`Offres prioritaires du club ${club.clubCode} - ${club.clubName}`);
    this.router.navigate(['/admin/offer-priority'], { queryParams: { clubCode: club.clubCode, clubName: club.clubName } });
  }

  private getClubs(): void {
    this.clubService.getClubDetails().subscribe({
      next: clubs => {
        this.dataSource = new MatTableDataSource<ClubDetails>(clubs);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.length = clubs.length;
      }
    });
  }

  private initComponent(): void {
    if (this.route.snapshot.queryParams.clubCode) { this.dataService.showDetailsClubPriority$.next(true); }
    this.getClubs();
  }

  private initSub(): void {
    this.subscription
      .add(
        this.dataService.showDetailsClubPriority$.subscribe({
          next: showDetailsClubPriority => {
            this.showDetailsClubPriority = showDetailsClubPriority;
            if (!showDetailsClubPriority) { this.getClubs(); }
            this.cdr.detectChanges();
          }
        })
      )
      .add(
        this.dataService.valueFilterOfferPriority$.subscribe({
          next: valueInput => {
            this.valueInput = valueInput;
            if (!this.showDetailsClubPriority) {
              this.dataSource.filter = this.valueInput?.trim().toLowerCase();
            }
            this.cdr.detectChanges();
          }
        })
      );
  }
}
